
import { Component, Prop } from 'vue-property-decorator';
import Page from '@/Page.vue';

@Component({})
export default class DashboardCardView extends Page {
    @Prop() title!: string;
    @Prop() link!: string;
    @Prop() linkTitle!: string;
    @Prop() secondLink!: string;
    @Prop() secondLinkTitle!: string;
}
